import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { WARN, DANGER } from 'conversations-message-history/common-message-format/constants/emailAuthenticationStatusTypes';
// @ts-expect-error module not typed
import { provideThreadView } from '../../thread-view/decorators/provideThreadView';
import { getOriginalGenericChannelId, getIsFiltered } from 'conversations-thread-data/thread-details/public/operators';
import { useThreadDetails } from '../../thread-details-feature/public/hooks/useThreadDetails';
// @ts-expect-error module not typed
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getUpdatedConversation } from '../../usage-tracking/utils/threadInteraction';
import { getEmailAndAuthenticationStatus } from '../selectors/getEmailAndAuthenticationStatus';
import { useLocalStorage } from '../../common/hooks/useLocalStorage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConnectedMessageAuthenticityAlertComponent = ({
  threadId
}) => {
  const {
    asyncThreadDetails,
    markAsSpam
  } = useThreadDetails({
    threadId
  });
  const threadDetails = getData(asyncThreadDetails);
  const genericChannelId = getOriginalGenericChannelId(threadDetails);
  const [hasDismissedAlertForThread, setHasDismissedAlertForThread] = useLocalStorage({
    key: `EMAIL_AUTHENTICATION_STATUS_ALERT_${threadId}`,
    initialValue: 'false'
  });
  const {
    email,
    authenticationStatus
  } = useSelector(getEmailAndAuthenticationStatus);
  if (!threadDetails || getIsFiltered(threadDetails)) {
    return null;
  }
  const handleMarkAsSpam = () => {
    markAsSpam();
    trackEvent( /*  @ts-expect-error Jun-5-2024, 19:34UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
    getUpdatedConversation({
      updateType: 'mark spam',
      genericChannelId
    }));
  };
  if (typeof authenticationStatus !== 'string') {
    return null;
  }
  const shouldRender = [WARN, DANGER].includes(authenticationStatus) && hasDismissedAlertForThread !== 'true';
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    use: "inline",
    type: "danger",
    minBlockSize: "unset",
    closeable: true,
    onClose: () => setHasDismissedAlertForThread('true'),
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.alerts.EMAIL_AUTHENTICATION_STATUS.danger.title"
    }),
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "conversations-thread-view.alerts.EMAIL_AUTHENTICATION_STATUS.danger.description",
        options: {
          email
        }
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Button, {
          marginBlock: "300",
          use: "tertiary",
          size: "extra-small",
          onClick: handleMarkAsSpam,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-thread-view.alerts.EMAIL_AUTHENTICATION_STATUS.danger.button"
          })
        })
      })]
    })
  });
};
ConnectedMessageAuthenticityAlertComponent.displayName = 'ConnectedMessageAuthenticityAlert';
const ConnectedMessageAuthenticityAlert = provideThreadView(ConnectedMessageAuthenticityAlertComponent);
ConnectedMessageAuthenticityAlert.component = ConnectedMessageAuthenticityAlertComponent;
export default ConnectedMessageAuthenticityAlert;